import { type InjectedIntlProps, injectIntl } from "react-intl";

import { GuidancePanel } from "../styles";

interface Props {
  /** data-testid on the panel (e.g. "paypal-notice", "direct-debit-notice"). */
  testId: string;
  /** intl message id for the guidance copy. */
  messageId: string;
  /** English fallback for the guidance copy. */
  defaultMessage: string;
}

/**
 * Plain, centered guidance panel for the redirect-based payment methods
 * (PayPal / Direct Debit), which have no fields to fill — the payment is
 * completed via the gateway redirect when the order is placed. Both methods
 * render identical chrome (only the testid and copy differ), so they share this
 * one component. (Invoice is intentionally a different, louder InfoBanner.)
 */
function GuidanceNoticeBase({
  testId,
  messageId,
  defaultMessage,
  intl,
}: Props & InjectedIntlProps) {
  return (
    <GuidancePanel data-testid={testId}>
      {intl.formatMessage({ id: messageId, defaultMessage })}
    </GuidancePanel>
  );
}

export const GuidanceNotice = injectIntl(GuidanceNoticeBase);
